import React, { useContext } from "react";
import { Button as ButtonLib } from "@npm_leadtech/qr-ui-components";
import { FiChevronLeft } from "react-icons/fi";
import { FEEDBACK_PREVIEW_INDEX } from "@/utils/feedbackPreviewNavigation";
import { QRFeedbackContextProps } from "@/contexts/QRFeedbackContext/types";
import { QRFeedbackContext } from "@/contexts/QRFeedbackContext";
import { useTranslation } from "react-i18next";

type FeedbackNavigationProps = {
  hasMultipleCategories: boolean;
};

export const FeedbackNavigation = ({ hasMultipleCategories }: FeedbackNavigationProps) => {
  const qrFeedbackContextData = useContext<QRFeedbackContextProps>(QRFeedbackContext);
  const { currentView, setCurrentView } = qrFeedbackContextData;
  const { t } = useTranslation("feedback");

  const handleFeedbackBackNav = () => {
    if (currentView === FEEDBACK_PREVIEW_INDEX.ADD_INFO) {
      setCurrentView(
        hasMultipleCategories
          ? FEEDBACK_PREVIEW_INDEX.HOME_MULTIPLE_CATEGORIES
          : FEEDBACK_PREVIEW_INDEX.HOME_SINGLE_CATEGORY
      );
    } else {
      setCurrentView(currentView - 1);
    }
  };

  return (
    <div className="feedback-template__navigation">
      <ButtonLib
        shape="ghost"
        iconLeft={<FiChevronLeft />}
        dataQA="feedback-back-button"
        label={t("back_button_label")}
        onClick={handleFeedbackBackNav}
        size="small"
      />
    </div>
  );
};
